const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) return parts.pop().split(';').shift();

  return false;
};

const setCookieForDay = (name, value) => {
  let date = new Date();
  date = new Date(date.setDate(date.getDate() + 1));
  const expires = date.toUTCString();

  document.cookie = `${name}=${value}; expires=${expires}"; path=/`;
};

const setCookieForYear = (name, value) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + 1);
  const expires = date.toUTCString();

  document.cookie = `${name}=${value}; expires=${expires}"; path=/`;
};

export { getCookie, setCookieForDay, setCookieForYear };
